import { defineMessages } from "@/i18n";
import en from "./en";

export const signupMessages = defineMessages("signup", en);
